import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MediaQueryService implements OnDestroy {
  private mqList: MediaQueryList | null = null;
  private mqListener: ((e: MediaQueryListEvent) => void) | null = null;

  /** Emits true/false depending on whether the query matches */
  private readonly matchesSubject = new BehaviorSubject<boolean>(false);
  public matches$ = this.matchesSubject.asObservable();

  /**
   * Starts watching a media query, e.g. '(max-width: 767px)'
   */
  watchQuery(query: string) {
    // Clean up any previous listener
    this.cleanup();

    this.mqList = globalThis.matchMedia(query);
    this.matchesSubject.next(this.mqList.matches);

    this.mqListener = (event) => {
      this.matchesSubject.next(event.matches);
    };

    this.mqList.addEventListener('change', this.mqListener);
  }

  /** Returns the current match state synchronously */
  get currentMatch(): boolean {
    return this.mqList?.matches ?? false;
  }

  private cleanup() {
    if (this.mqList && this.mqListener) {
      this.mqList.removeEventListener('change', this.mqListener);
    }
  }

  ngOnDestroy() {
    this.cleanup();
  }
}
